import Footer from '../components/qualitylodgings/Footer';
import Navigation from '../components/qualitylodgings/Navigation';
import { SearchRentalUnitsOrderEnum, UnitSearchOrderEnum } from '../generated/graphql';
import { BrandConfig } from './brandConfig';
import { rentalUnitTypes } from './filterTypes';
import qualitylodgings from '../themes/qualitylodgings';

const qualitylodgingsConfig: BrandConfig = {
    name: 'Qualitylodgings',
    noindex: true,
    locales: ['nl', 'de', 'en'],
    gtmID: 'GTM-NJ73VZG',
    theme: qualitylodgings,
    initialNewsletterChecked: true,
    font: {
        hrefs: [
            '/static/font/Gilroy-Bold.woff',
            '/static/font/Gilroy-Bold.woff2',
            '/static/font/Gilroy-BoldItalic.woff',
            '/static/font/Gilroy-BoldItalic.woff2',
            '/static/font/Gilroy-Regular.woff',
            '/static/font/Gilroy-Regular.woff2',
            '/static/font/Gilroy-RegularItalic.woff',
            '/static/font/Gilroy-RegularItalic.woff2',
        ],
        css: `
        // Gilroy
        @font-face {
            font-family: 'Gilroy';
            src: url('/static/font/Gilroy-Regular.woff2') format('woff2'), url('/static/font/Gilroy-Regular.woff') format('woff');
            font-weight: 400;
            font-display: swap;
        }

        @font-face {
            font-family: 'Gilroy';
            src: url('/static/font/Gilroy-Bold.woff2') format('woff2'), url('/static/font/Gilroy-Bold.woff') format('woff');
            font-weight: 700;
            font-display: swap;
        }


    `,
    },
    globalStyling: `
        .searchbar {
            top: 6rem !important;
            margin-bottom: 6rem;
        }

        .checkout-content-wrapper {
            padding-top: 12rem !important;
        }

        @media screen and (min-width: ${qualitylodgings.mediaQueries.m}) {
            .tips-image-container {
                aspect-ratio: unset !important;
                height: 100%;
            }
        }

        .newsletter-popup__wrapper--visible {
            display: none !important;
        }
    `,
    hasReviews: true,
    customContent: {
        Navigation: () => <Navigation />,
        Footer: () => <Footer />,
    },
    contact: {},
    accommodationTypes: [
        {
            // not a valid filter, so make sure to escape the value when using it
            message: 'all',
            value: 'all',
        },
        {
            message: 'hotelOrBnB',
            value: rentalUnitTypes.ROOM,
        },
    ],
    groupTypes: ['adults', 'youth', 'children', 'babies', 'pets'],
    unitSearchOrder: {
        popularity: SearchRentalUnitsOrderEnum.RandomBoosted,
        ratingDesc: SearchRentalUnitsOrderEnum.ReviewRatingDesc,
    },
    tripsSearchOrder: {
        popularity: UnitSearchOrderEnum.RandomBoosted,
        ratingDesc: UnitSearchOrderEnum.ReviewRatingDesc,
        priceAsc: UnitSearchOrderEnum.PriceAsc,
        priceDesc: UnitSearchOrderEnum.PriceDesc,
    },
    // Map zoom level: zoomed out so the initial view shows the Netherlands and part of Europe (Germany/France)
    mapZoom: 6,

    // Map min zoom level
    mapMinZoom: {
        desktop: 5,
        mobile: 5,
    },
    // Centre of the Netherlands (instead of focused on Ameland) so the default view covers NL + neighbouring countries
    coordinates: {
        latitude: 52.1326,
        longitude: 5.2913,
    },
    seo: {
        siteName: 'Quality Lodgings',
    },
    minBookingAge: 18,
    cancellationInsuranceDefault: true,
    complaintFormUrl: {
        nl: 'https://qualitylodgings.com/nl/contact',
        de: 'https://qualitylodgings.com/de/kontakt',
        en: 'https://qualitylodgings.com/en/contact',
    },
    termsAndConditions: {
        nl: 'https://qualitylodgings.com/nl/centrale-boekingsvoorwaarden',
        de: 'https://qualitylodgings.com/de/zentralen-buchungsbedingungen',
        en: 'https://qualitylodgings.com/en/Central-Booking-Conditions',
    },
    homepageUrl: {
        nl: 'https://qualitylodgings.com/nl',
        de: 'https://qualitylodgings.com/de',
        en: 'https://qualitylodgings.com/en',
    },
    accommodationPage: {
        hideSearchbar: true,
        hideContactButton: true,
        hideInformationButton: true,
        hideSurchargeExplanation: true,
        showAccommodationNameAsOwner: true,
    },
    searchBar: {
        active: ['location', 'tripgroup', 'datepicker'],
    },
};

export default qualitylodgingsConfig;
